import { useMutation, useQueryClient } from "@tanstack/react-query";
import { approveShipment } from "../../../services/supplierOrderService";
import { shipmentKeys } from "../queryKeys";

export const useApproveShipment = () => {

  const queryClient = useQueryClient();

  return useMutation({

    mutationFn: ({ shipmentCode, data }) =>
      approveShipment(shipmentCode, data),

    onSuccess: (_, variables) => {

      queryClient.invalidateQueries(shipmentKeys.all);

      queryClient.invalidateQueries(
        shipmentKeys.detail(variables.shipmentCode)
      );
    },

  });

};
